// @ts-strict-ignore
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { tap } from "rxjs/operators";
import { LogService } from "src/app/shared/services/log.service";
import { AuthActions } from "./auth.actions.types";

export const AUTH_EFFECT_REDIRECT_QUERYPARAM_IDENTIFIER_TOKEN = "AUTH_EFFECT_REDIRECT_QUERYPARAM_IDENTIFIER_TOKEN";
@Injectable()
export class AuthEffects {
  constructor(
    private actions$: Actions,
    private router: Router,
    private logService: LogService
  ) {}

  public redirectQueryParams: Record<string, unknown> = {};
  authLogout$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(AuthActions.Logout),
        tap(async () => {
          this.logService.log("[AuthEffects] authLogout$ => Logging out of application");
          const redirectParams = localStorage.getItem(AUTH_EFFECT_REDIRECT_QUERYPARAM_IDENTIFIER_TOKEN);
          sessionStorage.clear();
          localStorage.clear();
          await this.router.navigate([`/auth`], {
            queryParams: JSON.parse(redirectParams)
          });
        })
      );
    },
    { dispatch: false }
  );
}
